import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance, diyInstance } from './instance'

export default class DataReceptionService {
  // 添加数据质量维度、规则权重
  static async addDataQualityDimension(payload) {
    const [err, res] = await To(
      wizStandardInstance.put('/api/std/StdDataQualityDimension/add', payload)
    )
    return Callback(err, res)
  }
  // 获取数据质量维度、规则权重列表
  static async getDataQualityDimension(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityDimension?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取质量评分统计数据
  static async getDataQualityStatistics(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityScore/get-statistics', payload)
    )
    return Callback(err, res)
  }
  // 质量维度评分列表
  static async getDimensionScoreList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityScore/get-dimension-score-list', payload)
    )
    return Callback(err, res)
  }
  // 质量维度评分趋势
  static async getDimensionScoreTrend(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityScore/get-trend', payload)
    )
    return Callback(err, res)
  }
  // 标准库质量评分列表
  static async getstandardScoreAnalysis(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityScore/standard-score-analysis?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 标准库质量评分趋势
  static async getStandardScoreTrend(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityScore/standard-score-trend?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 实体质量评分Bot5/Top5
  static async getClassStatistics(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityScore/get-class-statistics', payload)
    )
    return Callback(err, res)
  }
  // 时间统计数据
  static async getDateStatistics(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityScore/get-date-statistics', payload)
    )
    return Callback(err, res)
  }
  // 时间评分趋势
  static async getDateScoreTrend(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityScore/date-score-trend', payload)
    )
    return Callback(err, res)
  }
}
